import { render, staticRenderFns } from "./AccountDialog.vue?vue&type=template&id=64cf7e24"
import script from "./AccountDialog.vue?vue&type=script&lang=ts"
export * from "./AccountDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports